export const prefix = "kestrel";

export const entryRouteIdAttribute = "data-kestrel-route";

export const entryAppIdAttribute = "data-kestrel-app";

export const entryIslandAttribute = "data-kestrel-island";

export const serverDataMime = "application/encoded+json; encoding=url;";
